import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';

// GET Plans List
export const REQUEST_PLANS = 'REQUEST_PLANS';
export const REQUEST_PLANS_SUCCESS = 'REQUEST_PLANS_SUCCESS';
export const REQUEST_PLANS_FAILURE = 'REQUEST_PLANS_FAILURE';
export const ACTION_REQUEST_PLANS = 'ACTION_REQUEST_PLANS';

// GET Plan Detail
export const REQUEST_PLAN_DETAIL = 'REQUEST_PLAN_DETAIL';
export const REQUEST_PLAN_DETAIL_SUCCESS = 'REQUEST_PLAN_DETAIL_SUCCESS';
export const REQUEST_PLAN_DETAIL_FAILURE = 'REQUEST_PLAN_DETAIL_FAILURE';
export const ACTION_REQUEST_PLAN_DETAIL = 'ACTION_REQUEST_PLAN_DETAIL';

// Cancel Subscription
export const REQUEST_CANCEL_SUBSCRIPTION = 'REQUEST_CANCEL_SUBSCRIPTION';
export const REQUEST_CANCEL_SUBSCRIPTION_SUCCESS = 'REQUEST_CANCEL_SUBSCRIPTION_SUCCESS';
export const REQUEST_CANCEL_SUBSCRIPTION_FAILURE = 'REQUEST_CANCEL_SUBSCRIPTION_FAILURE';
export const ACTION_CANCEL_SUBSCRIPTION = 'ACTION_CANCEL_SUBSCRIPTION';

// Restore Subscription
export const REQUEST_RESTORE_SUBSCRIPTION = 'REQUEST_RESTORE_SUBSCRIPTION';
export const REQUEST_RESTORE_SUBSCRIPTION_SUCCESS = 'REQUEST_RESTORE_SUBSCRIPTION_SUCCESS';
export const REQUEST_RESTORE_SUBSCRIPTION_FAILURE = 'REQUEST_RESTORE_SUBSCRIPTION_FAILURE';
export const ACTION_RESTORE_SUBSCRIPTION = 'ACTION_RESTORE_SUBSCRIPTION';

// Buy Plan
export const REQUEST_BUY_PLAN = 'REQUEST_BUY_PLAN';
export const REQUEST_BUY_PLAN_SUCCESS = 'REQUEST_BUY_PLAN_SUCCESS';
export const REQUEST_BUY_PLAN_FAILURE = 'REQUEST_BUY_PLAN_FAILURE';
export const ACTION_BUY_PLAN = 'ACTION_BUY_PLAN';

// Subscription Payment
export const REQUEST_SUBSCRIPTION_PAYMENT = 'REQUEST_SUBSCRIPTION_PAYMENT';
export const REQUEST_SUBSCRIPTION_PAYMENT_SUCCESS = 'REQUEST_SUBSCRIPTION_PAYMENT_SUCCESS';
export const REQUEST_SUBSCRIPTION_PAYMENT_FAILURE = 'REQUEST_SUBSCRIPTION_PAYMENT_FAILURE';
export const ACTION_SUBSCRIPTION_PAYMENT = 'ACTION_SUBSCRIPTION_PAYMENT';

// Enterprise Request
export const REQUEST_ENTERPRISE_REQUEST = 'REQUEST_ENTERPRISE_REQUEST';
export const REQUEST_ENTERPRISE_REQUEST_SUCCESS = 'REQUEST_ENTERPRISE_REQUEST_SUCCESS';
export const REQUEST_ENTERPRISE_REQUEST_FAILURE = 'REQUEST_ENTERPRISE_REQUEST_FAILURE';
export const ACTION_ENTERPRISE_REQUEST = 'ACTION_ENTERPRISE_REQUEST';
export const RESET_ENTERPRISE_REQUEST_STATE = 'RESET_ENTERPRISE_REQUEST_STATE';

const defaultState = {
  // Plans List
  plans: [],
  plansError: null,
  fetchingPlans: false,
  failedFetchingPlans: false,

  // Plan Detail
  planDetail: null,
  planDetailError: null,
  fetchingPlanDetail: false,
  failedFetchingPlanDetail: false,

  // Cancel Subscription
  cancelingSubscription: false,
  cancelSubscriptionSuccess: false,
  cancelSubscriptionFailure: false,
  cancelSubscriptionError: null,

  // Restore Subscription
  restoringSubscription: false,
  restoreSubscriptionSuccess: false,
  restoreSubscriptionFailure: false,
  restoreSubscriptionError: null,

  // Buy Plan
  buyingPlan: false,
  buyPlanSuccess: false,
  buyPlanFailure: false,
  buyPlanError: null,
  buyPlanOrderId: null,

  // Subscription Payment
  creatingSubscriptionPayment: false,
  subscriptionPaymentSuccess: false,
  subscriptionPaymentFailure: false,
  subscriptionPaymentError: null,

  // Enterprise Request
  submittingEnterpriseRequest: false,
  enterpriseRequestSuccess: false,
  enterpriseRequestFailure: false,
  enterpriseRequestError: null,
};

const reducer = createReducer(defaultState, {
  [REQUEST_PLANS]: (state) => ({
    ...state,
    fetchingPlans: true,
    failedFetchingPlans: false,
    plansError: null,
  }),
  [REQUEST_PLANS_SUCCESS]: (state, action) => ({
    ...state,
    fetchingPlans: false,
    failedFetchingPlans: false,
    plans: action.payload?.data || [],
  }),
  [REQUEST_PLANS_FAILURE]: (state, action) => ({
    ...state,
    fetchingPlans: false,
    failedFetchingPlans: true,
    plansError: action.payload,
  }),

  [REQUEST_PLAN_DETAIL]: (state) => ({
    ...state,
    fetchingPlanDetail: true,
    failedFetchingPlanDetail: false,
    planDetailError: null,
  }),
  [REQUEST_PLAN_DETAIL_SUCCESS]: (state, action) => ({
    ...state,
    fetchingPlanDetail: false,
    failedFetchingPlanDetail: false,
    planDetail: action.payload?.data || null,
  }),
  [REQUEST_PLAN_DETAIL_FAILURE]: (state, action) => ({
    ...state,
    fetchingPlanDetail: false,
    failedFetchingPlanDetail: true,
    planDetailError: action.payload,
  }),

  [REQUEST_CANCEL_SUBSCRIPTION]: (state) => ({
    ...state,
    cancelingSubscription: true,
    cancelSubscriptionSuccess: false,
    cancelSubscriptionFailure: false,
    cancelSubscriptionError: null,
  }),
  [REQUEST_CANCEL_SUBSCRIPTION_SUCCESS]: (state) => ({
    ...state,
    cancelingSubscription: false,
    cancelSubscriptionSuccess: true,
    cancelSubscriptionFailure: false,
    cancelSubscriptionError: null,
  }),
  [REQUEST_CANCEL_SUBSCRIPTION_FAILURE]: (state, action) => ({
    ...state,
    cancelingSubscription: false,
    cancelSubscriptionSuccess: false,
    cancelSubscriptionFailure: true,
    cancelSubscriptionError: action.payload,
  }),

  [REQUEST_RESTORE_SUBSCRIPTION]: (state) => ({
    ...state,
    restoringSubscription: true,
    restoreSubscriptionSuccess: false,
    restoreSubscriptionFailure: false,
    restoreSubscriptionError: null,
  }),
  [REQUEST_RESTORE_SUBSCRIPTION_SUCCESS]: (state) => ({
    ...state,
    restoringSubscription: false,
    restoreSubscriptionSuccess: true,
    restoreSubscriptionFailure: false,
    restoreSubscriptionError: null,
  }),
  [REQUEST_RESTORE_SUBSCRIPTION_FAILURE]: (state, action) => ({
    ...state,
    restoringSubscription: false,
    restoreSubscriptionSuccess: false,
    restoreSubscriptionFailure: true,
    restoreSubscriptionError: action.payload,
  }),

  [REQUEST_BUY_PLAN]: (state) => ({
    ...state,
    buyingPlan: true,
    buyPlanSuccess: false,
    buyPlanFailure: false,
    buyPlanError: null,
    buyPlanOrderId: null,
  }),
  [REQUEST_BUY_PLAN_SUCCESS]: (state, action) => ({
    ...state,
    buyingPlan: false,
    buyPlanSuccess: true,
    buyPlanFailure: false,
    buyPlanError: null,
    buyPlanOrderId: action.payload?.data?.id || null,
  }),
  [REQUEST_BUY_PLAN_FAILURE]: (state, action) => ({
    ...state,
    buyingPlan: false,
    buyPlanSuccess: false,
    buyPlanFailure: true,
    buyPlanError: action.payload,
    buyPlanOrderId: null,
  }),

  [REQUEST_SUBSCRIPTION_PAYMENT]: (state) => ({
    ...state,
    creatingSubscriptionPayment: true,
    subscriptionPaymentSuccess: false,
    subscriptionPaymentFailure: false,
    subscriptionPaymentError: null,
  }),
  [REQUEST_SUBSCRIPTION_PAYMENT_SUCCESS]: (state) => ({
    ...state,
    creatingSubscriptionPayment: false,
    subscriptionPaymentSuccess: true,
    subscriptionPaymentFailure: false,
    subscriptionPaymentError: null,
  }),
  [REQUEST_SUBSCRIPTION_PAYMENT_FAILURE]: (state, action) => ({
    ...state,
    creatingSubscriptionPayment: false,
    subscriptionPaymentSuccess: false,
    subscriptionPaymentFailure: true,
    subscriptionPaymentError: action.payload,
  }),

  [REQUEST_ENTERPRISE_REQUEST]: (state) => ({
    ...state,
    submittingEnterpriseRequest: true,
    enterpriseRequestSuccess: false,
    enterpriseRequestFailure: false,
    enterpriseRequestError: null,
  }),
  [REQUEST_ENTERPRISE_REQUEST_SUCCESS]: (state) => ({
    ...state,
    submittingEnterpriseRequest: false,
    enterpriseRequestSuccess: true,
    enterpriseRequestFailure: false,
    enterpriseRequestError: null,
  }),
  [REQUEST_ENTERPRISE_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    submittingEnterpriseRequest: false,
    enterpriseRequestSuccess: false,
    enterpriseRequestFailure: true,
    enterpriseRequestError: action.payload,
  }),

  [RESET_ENTERPRISE_REQUEST_STATE]: (state) => ({
    ...state,
    submittingEnterpriseRequest: false,
    enterpriseRequestSuccess: false,
    enterpriseRequestFailure: false,
    enterpriseRequestError: null,
  }),
});

export default reducer;
export const namespace = 'plans';

// Actions
export const actionRequestPlans = () => ({
  type: ACTION_REQUEST_PLANS,
});

export const actionRequestPlanDetail = (planId) => ({
  type: ACTION_REQUEST_PLAN_DETAIL,
  payload: planId,
});

export const actionCancelSubscription = () => ({
  type: ACTION_CANCEL_SUBSCRIPTION,
});

export const actionRestoreSubscription = () => ({
  type: ACTION_RESTORE_SUBSCRIPTION,
});

export const actionBuyPlan = (planId) => ({
  type: ACTION_BUY_PLAN,
  payload: planId,
});

export const actionCreateSubscriptionPayment = (paymentData) => ({
  type: ACTION_SUBSCRIPTION_PAYMENT,
  payload: paymentData,
});

export const actionEnterpriseRequest = (requestData) => ({
  type: ACTION_ENTERPRISE_REQUEST,
  payload: requestData,
});

export const resetEnterpriseRequestState = () => ({
  type: RESET_ENTERPRISE_REQUEST_STATE,
});

// API Calls
export const getPlansAPI = () => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/plans',
    actionTypes: [REQUEST_PLANS, REQUEST_PLANS_SUCCESS, REQUEST_PLANS_FAILURE],
    variables: {},
    dispatch,
    getState,
  });
};

export const getPlanDetailAPI = (planId) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: `/plans/${planId}`,
    actionTypes: [REQUEST_PLAN_DETAIL, REQUEST_PLAN_DETAIL_SUCCESS, REQUEST_PLAN_DETAIL_FAILURE],
    variables: {},
    dispatch,
    getState,
  });
};

export const cancelSubscriptionAPI = () => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/plans/cancel-subscription',
    actionTypes: [
      REQUEST_CANCEL_SUBSCRIPTION,
      REQUEST_CANCEL_SUBSCRIPTION_SUCCESS,
      REQUEST_CANCEL_SUBSCRIPTION_FAILURE,
    ],
    variables: {},
    dispatch,
    getState,
  });
};

export const restoreSubscriptionAPI = () => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/plans/resubscribe',
    actionTypes: [
      REQUEST_RESTORE_SUBSCRIPTION,
      REQUEST_RESTORE_SUBSCRIPTION_SUCCESS,
      REQUEST_RESTORE_SUBSCRIPTION_FAILURE,
    ],
    variables: {},
    dispatch,
    getState,
  });
};

export const buyPlanAPI = (planId) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: `/orders/buy-plan/${planId}`,
    actionTypes: [REQUEST_BUY_PLAN, REQUEST_BUY_PLAN_SUCCESS, REQUEST_BUY_PLAN_FAILURE],
    variables: {},
    dispatch,
    getState,
  });
};

export const createSubscriptionPaymentAPI = (paymentData) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/payments/subscription',
    actionTypes: [
      REQUEST_SUBSCRIPTION_PAYMENT,
      REQUEST_SUBSCRIPTION_PAYMENT_SUCCESS,
      REQUEST_SUBSCRIPTION_PAYMENT_FAILURE,
    ],
    variables: paymentData,
    dispatch,
    getState,
  });
};

export const submitEnterpriseRequestAPI = (requestData) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/enterprise/request',
    actionTypes: [
      REQUEST_ENTERPRISE_REQUEST,
      REQUEST_ENTERPRISE_REQUEST_SUCCESS,
      REQUEST_ENTERPRISE_REQUEST_FAILURE,
    ],
    variables: requestData,
    dispatch,
    getState,
  });
};
